import React from 'react';

export const SkeletonCard = () => (
  <div className="card p-4">
    <div className="skeleton rounded-xl w-full h-48 mb-4" />
    <div className="skeleton h-4 rounded w-3/4 mb-2" />
    <div className="skeleton h-3 rounded w-full mb-1" />
    <div className="skeleton h-3 rounded w-2/3 mb-4" />
    <div className="flex justify-between items-center">
      <div className="skeleton h-5 rounded w-16" />
      <div className="skeleton h-9 rounded-lg w-24" />
    </div>
  </div>
);

export const SkeletonRow = () => (
  <div className="flex items-center gap-4 py-3 border-b border-bark-100">
    <div className="skeleton rounded-lg w-12 h-12 flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <div className="skeleton h-4 rounded w-1/3" />
      <div className="skeleton h-3 rounded w-1/2" />
    </div>
    <div className="skeleton h-6 rounded-full w-20" />
  </div>
);

export const SkeletonText = ({ lines = 3 }) => (
  <div className="space-y-2">
    {Array.from({ length: lines }).map((_, i) => (
      <div key={i} className={`skeleton h-4 rounded ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />
    ))}
  </div>
);

const Skeleton = { Card: SkeletonCard, Row: SkeletonRow, Text: SkeletonText };
export default Skeleton;
